import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  InputSignal,
  Signal
} from '@angular/core';
import { FormattedCurrencyPipe } from '../../../../shared/pipes/formatted-currency.pipe';
import { KeyValuePipe } from '@angular/common';
import { WooCommerceCheckoutProductItemMeta } from '../../../../core/interfaces/woo-commerce/api/checkout/checkout-api.interface';

interface WooCommerceCheckoutProductItemMetaPrice
  extends WooCommerceCheckoutProductItemMeta {
  price: number;
}

interface GroupedAddOnItem
  extends Omit<WooCommerceCheckoutProductItemMetaPrice, 'label'> {
  price: number;
}

type GroupedAddOns = Record<string, GroupedAddOnItem[]>;

@Component({
  selector: 'app-order-cart-item',
  templateUrl: './order-cart-item.component.html',
  styleUrl: './order-cart-item.component.scss',
  imports: [FormattedCurrencyPipe, KeyValuePipe],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class OrderCartItemComponent {
  count: InputSignal<number> = input(1);
  name: InputSignal<string> = input('Ceasar Salad');
  price: InputSignal<string | number> = input<string | number>(10);
  variantName: InputSignal<string | null | undefined> = input<string | null | undefined>(null);

  addOns: InputSignal<WooCommerceCheckoutProductItemMeta[]> = input<
    WooCommerceCheckoutProductItemMeta[]
  >([]);

  groupedAddOns: Signal<GroupedAddOns> = computed((): GroupedAddOns => {
    const addOns: WooCommerceCheckoutProductItemMeta[] = this.addOns();
    return this.groupByName(addOns);
  });

  // TODO: Move to separate service/util
  private groupByName(
    rawItems: WooCommerceCheckoutProductItemMeta[]
  ): GroupedAddOns {
    const grouped: GroupedAddOns = {};
    const items = rawItems
      .filter((rawItem) => {
        const hasLabel = !!rawItem?.label && String(rawItem.label).trim() !== '';
        const hasValue = !!rawItem?.value && String(rawItem.value).trim() !== '';
        return hasLabel || hasValue;
      })
      .map((rawItem) => this.expandAddOn(rawItem));

    for (const item of items) {
      const { label, ...rest } = item;
      const groupKey = label || 'Options';

      if (!grouped[groupKey]) {
        grouped[groupKey] = [];
      }

      grouped[groupKey].push(rest);
    }

    return grouped;
  }

  private expandAddOn(
    item: WooCommerceCheckoutProductItemMeta
  ): WooCommerceCheckoutProductItemMetaPrice {
    if ((item as any)?.price != null && (item as any).price !== '') {
      const numericPrice = Number((item as any).price);
      return {
        ...item,
        price: Number.isFinite(numericPrice) ? numericPrice : 0
      };
    }

    const match: RegExpMatchArray | null =
      item.label.match(/&#36;(\d+\.\d{2})/);
    const price: number | null = match ? parseFloat(match[1]) : null;
    const cleanedName: string = item.label.replace(
      /\s*\(&#36;\d+\.\d{2}\)/,
      ''
    );

    return { ...item, label: cleanedName, price: price || 0 };
  }
}
